/** A typed `graphql()` row with its `null` fields read as `undefined`, the base generated types' empty value. */
export type NullsToUndefined<T> = { [K in keyof T]: null extends T[K] ? Exclude<T[K], null> | undefined : T[K] }

/** Normalizes a flat typed-query row at the boundary so it fits the base generated model types. */
export function nullsToUndefined<T extends object>(row: T): NullsToUndefined<T> {
  return Object.fromEntries(Object.entries(row).map(([key, value]) => [key, value ?? undefined])) as NullsToUndefined<T>
}
